import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'
import api from 'api'

const CREATE_REQUEST = 'realhub/portalOption/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/portalOption/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/portalOption/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/portalOption/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/portalOption/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/portalOption/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  deleting: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']


// Action Creators
export function deletePortalOption(option, options){
  const config = {
    method: 'DELETE',
  }
  return (dispatch, getState) => {
    // Set Loading
    dispatch(deleteRequest())
    const url = `/admin/portals/${option.portal_id}/options/${option.id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Remove from result array
        const resultArray = getState().portalOptions.result ? getState().portalOptions.result.slice() : []
        const index = resultArray.indexOf(json.id)
        if (!resultArray.includes(json.id)){
          resultArray.splice(index, 1)
        }

        const normalizedJson = normalize(json, Schemas.PORTAL_OPTION)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function createPortalOption(option, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      portal_option: option,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/portals/${option.portal_id}/options.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to result array
        const resultArray = getState().portalOptions.result ? getState().portalOptions.result.slice() : []
        if (!resultArray.includes(json.id)){
          resultArray.push(json.id)
        }

        const normalizedJson = normalize(json, Schemas.PORTAL_OPTION)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess({ result: resultArray }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
